module.exports = __webpack_public_path__ + "img/prexange_services_1.513ee3fd.png";